import React from 'react';
import styled from 'styled-components';

import { useTranslation } from '@lt/localization';
import { CurrencyFormat } from '@lt/components';
import {
  pluralizeNights,
  pluralizeAdults,
} from '@lt/components/utils/pluralizeUtils';

import type { IPopularDestinationsOfferWithPrice } from 'src/routes/Home/store/popularDestinationsOffers/types';

type ICardHeadingBlock = Omit<
  IPopularDestinationsOfferWithPrice,
  'regions' | 'link' | 'imageUrl'
>;

export const CardHeadingBlock = (props: ICardHeadingBlock) => {
  const { place, minPrice, nights, adults } = props;

  const { t } = useTranslation();

  const secondRowText = `${nights} ${pluralizeNights(
    nights,
  )}, ${adults} ${pluralizeAdults(adults)}`;

  return (
    <ContentHeadingContainer>
      <ContentHeadingFirstRow>
        <StyledCountryName>{place}</StyledCountryName>
        <CurrencyFormat
          value={minPrice}
          prefix={`${t('filters.prices.from')} `}
        />
      </ContentHeadingFirstRow>
      <ContentHeadingSecondRow>{secondRowText}</ContentHeadingSecondRow>
    </ContentHeadingContainer>
  );
};

const ContentHeadingContainer = styled.div`
  width: 100%;
  height: 40px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  color: #fff;
`;

const ContentHeadingFirstRow = styled.div`
  width: 100%;

  display: flex;
  justify-content: space-between;

  font-size: 18px;
  line-height: 22px;
`;

const ContentHeadingSecondRow = styled.div`
  font-size: 12px;
  line-height: 16px;
`;

const StyledCountryName = styled.div`
  font-weight: 700;
`;
